<template>
  <div class="certificate">
    <el-dialog
      title="导出证书"
      :visible.sync="global.dialogVisible"
      width="50%"
      height="500px"
      :show-close="false"
    >
      <el-table
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelect"
        height="500px"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          type="index"
          label="序号"
          width="80"
        />
        <el-table-column
          prop="name"
          label="姓名"
          width="180"
        />
        <el-table-column
          prop="id_number"
          label="身份证号"
          width="200"
        />
        <el-table-column
          prop="createTime"
          label="培训时间"
          width="200"
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="station_id"
          label="岗位"
          width="200"
        >
          <template slot-scope="scope">
            {{ global.getName(global.stationList, scope.row.station_id, 'station') }}
          </template>
        </el-table-column>
      </el-table>
      <el-button
        type="primary"
        @click="exportData"
      >
        导出证书
      </el-button>
      <el-button
        type="primary"
        @click="close"
      >
        返回
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      selectedRows: []
    }
  },
  computed: {
    tableData () {
      // 数组倒序
      let data = this.global.exportList
      return data.reverse()
    }
  },
  methods: {
    formatDate (dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getUTCFullYear()
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const day = String(date.getUTCDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    stationName (id) {
      let stationList = this.global.stationList
      return this.global.getName(stationList, id, 'station')
    },
    close () {
      this.global.dialogVisible = false
      this.selectedRows = []
    },
    handleSelect (val) {
      console.log(val)
      this.selectedRows = val
    },
    async exportData () {
      if (this.selectedRows.length === 0) {
        this.$message({
          message: '请选择要导出的证书',
          type: 'warning'
        })
        return
      }
      // 引入依赖
      const jszipModule = await import('jszip')
      const JSZip = jszipModule.default || jszipModule
      const { saveAs } = await import('file-saver')

      // 创建ZIP实例
      const zip = new JSZip()

      // 逐个生成图片并添加到zip
      for (let i = 0; i < this.selectedRows.length; i++) {
        const row = this.selectedRows[i]

        // 创建canvas元素
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        // 设置画布尺寸
        canvas.width = 1080
        canvas.height = 764

        try {
          // 加载背景图片
          const backgroundImage = new Image()
          backgroundImage.src = require('@/assets/backBook.jpg')

          // 等待背景图片加载完成
          await new Promise((resolve, reject) => {
            backgroundImage.onload = () => resolve()
            backgroundImage.onerror = () => {
              // 如果背景图片加载失败，继续执行而不使用背景
              console.warn('背景图片加载失败，使用纯白背景')
              resolve()
            }
          })

          // 绘制背景图片，如果没有背景图片则保持白色背景
          if (backgroundImage.complete && backgroundImage.naturalWidth !== 0) {
            // 绘制背景图片，覆盖整个画布
            ctx.globalAlpha = 1
            ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height)
            ctx.globalAlpha = 1.0
          } else {
            // 如果没有背景图片，绘制白色背景
            ctx.fillStyle = '#ffffff'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
          }

          // 设置标题字体
          ctx.font = 'bold 48px SimSun, SimHei, Arial, sans-serif'
          ctx.fillStyle = '#003399' // 深蓝色
          ctx.textAlign = 'center'

          // 添加装饰线
          ctx.strokeStyle = '#003399'
          ctx.lineWidth = 1
          ctx.beginPath()
          ctx.moveTo(canvas.width / 2 - 100, 180)
          ctx.lineTo(canvas.width / 2 - 50, 180)
          ctx.stroke()

          ctx.beginPath()
          ctx.moveTo(canvas.width / 2 + 50, 180)
          ctx.lineTo(canvas.width / 2 + 100, 180)
          ctx.stroke()

          // 绘制中间点
          ctx.fillStyle = '#003399'
          ctx.beginPath()
          ctx.arc(canvas.width / 2, 180, 5, 0, Math.PI * 2)
          ctx.fill()

          // 设置正文字体
          ctx.font = '20px SimSun, SimHei, Arial, sans-serif'
          ctx.fillStyle = '#000000' // 黑色
          ctx.textAlign = 'left'
          const formatDate = (date) => {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}年${month}月${day}日`
          }
          // 计算开始日期（从createTime往前推一个月）
          const createDate = new Date(row.createTime)
          const startDate = new Date(createDate)
          startDate.setMonth(startDate.getMonth() - 1)

          // 绘制学员姓名
          const userName = `${row.name || '学员'}`
          ctx.fillText(userName, 120, 300)

          // 绘制培训详情
          const trainDetails = `  于 ${formatDate(startDate)}——${formatDate(createDate)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，完成${row.hour || 20}学时（60分钟/学时），符合要求。`
          this.wrapText(ctx, trainDetails, 120, 350, canvas.width - 240, 30) // 缩进20px

          // 绘制公司名称
          ctx.textAlign = 'right' // 右对齐
          const company = '福建省海运集团中平船舶管理有限公司'
          ctx.fillText(company, canvas.width - 120, 550)

          // 绘制日期
          const date = formatDate(createDate)
          ctx.fillText(date, canvas.width - 120, 600)

          // 将canvas转为blob并添加到zip
          const dataUrl = canvas.toDataURL('image/png')
          const blob = await fetch(dataUrl).then(res => res.blob())

          // 使用姓名作为文件名
          const fileName = `学时证明_${row.name || '学员'}_${formatDate(createDate)}.png`
          zip.file(fileName, blob)

          console.log(`已添加图片: ${fileName}`)
        } catch (error) {
          console.error(`生成第${i + 1}张图片失败:`, error)
        }
      }

      // 生成zip文件并下载
      const content = await zip.generateAsync({ type: 'blob' })
      saveAs(content, '学时证明.zip')

      this.$message.success(`成功导出${this.selectedRows.length}张证书图片`)
    },
    wrapText (context, text, x, y, maxWidth, lineHeight) {
      const words = text.split('')
      let line = ''
      let currentY = y

      for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n]
        const metrics = context.measureText(testLine)
        const testWidth = metrics.width

        if (testWidth > maxWidth && n > 0) {
          context.fillText(line, x, currentY)
          line = words[n]
          currentY += lineHeight
        } else {
          line = testLine
        }
      }
      context.fillText(line, x, currentY)
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.certificate {
}
</style>



// WEBPACK FOOTER //
// src/page/certificate.vue